import React, { useState } from 'react';
import { MinusIcon, PlusIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="faq" className="scroll-mt-4 bg-white px-5 py-16 sm:py-20" data-id="element-67" data-mp="1lazbdaswhbdw">
      <div className="mx-auto max-w-3xl" data-id="element-68" data-mp="1gcxqqlftt40b">
        <h2 className="text-center font-display text-3xl font-black text-navy-800 sm:text-4xl" data-id="element-69" data-mp="1ge0ewllrkscj">
          Häufige <span className="text-gold-dark" data-id="element-70" data-mp="2dzxuaa4ukhk9">Fragen</span>
        </h2>

        <div className="mt-10 divide-y divide-slate-200 rounded-xl border border-slate-200" data-id="element-71" data-mp="2913c9aepex17">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={faq.question} data-id="element-72" data-mp="1z3ymz1pkalg6" data-mpi={index}>
                <h3 data-id="element-73" data-mp="1z2x96ph5vkur">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition-colors duration-150 ease-out hover:bg-slate-50 focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-gold" data-id="element-74" data-mp="sn3fg8b5nni6">
                    <span className="text-sm font-semibold text-navy-800 sm:text-base" data-id="element-75" data-mp="kil548nwvien">
                      {faq.question}
                    </span>
                    {isOpen ? <MinusIcon className="h-5 w-5 shrink-0 text-gold-dark" aria-hidden="true" data-id="element-76" data-mp="bi6i94vatv91" /> : <PlusIcon className="h-5 w-5 shrink-0 text-gold-dark" aria-hidden="true" data-id="element-77" data-mp="3swtsn2bktizy" />}
                  </button>
                </h3>
                {isOpen && <div id={`faq-panel-${index}`} className="px-5 pb-5 text-sm leading-relaxed text-slate-600" data-id="element-78" data-mp="3nz20c770ruv8">
                    {faq.answer}
                  </div>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}